/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.

  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
 ******************************************************************************************************************** */
export const LOCAL_STORAGE_KEY_NEW_VISIT_FLAG = 'ThreatStatementGenerator.newVisitFlag';

export const LOCAL_STORAGE_KEY_CURRENT_WORKSPACE = 'ThreatStatementGenerator.currentWorkspace';
export const LOCAL_STORAGE_KEY_WORKSPACE_LIST = 'ThreatStatementGenerator.workspaceList';

export const LOCAL_STORAGE_KEY_EDITING_STATEMENT = 'ThreatStatementGenerator.editingStatement';
export const LOCAL_STORAGE_KEY_STATEMENT_LIST = 'ThreatStatementGenerator.threatStatementList';

export const LOCAL_STORAGE_KEY_ASSUMPTION_LIST = 'ThreatStatementGenerator.AssumptionList';
export const LOCAL_STORAGE_KEY_MITIGATION_LIST = 'ThreatStatementGenerator.MitigationList';

export const LOCAL_STORAGE_KEY_ASSUMPTION_LINK_LIST = 'ThreatStatementGenerator.AssumptionLinkList';
export const LOCAL_STORAGE_KEY_MITIGATION_LINK_LIST = 'ThreatStatementGenerator.MitigationLinkList';

export const LOCAL_STORAGE_KEY_APPLICATION_INFO = 'ThreatStatementGenerator.ApplicationInfo';
export const LOCAL_STORAGE_KEY_ARCHIECTURE_INFO = 'ThreatStatementGenerator.ArchitectureInfo';
export const LOCAL_STORAGE_KEY_DATAFLOW_INFO = 'ThreatStatementGenerator.DataflowInfo';

export const LOCAL_STORAGE_KEY_WORKSPACE_LIST_MIGRATION = 'ThreatStatementGenerator.workspaceListMigration';
export const LOCAL_STORAGE_KEY_THREATS_LIST_MIGRATION = 'ThreatStatementGenerator.threatListMigration';


export const LOCAL_STORAGE_KEY_THEME_MODE = 'ThreatComposer.theme.mode';
export const LOCAL_STORAGE_KEY_THEME_DENSITY = 'ThreatComposer.theme.density';
